export default __webpack_public_path__ + "static/media/trash.bb8494aa.svg";